import { GetReservationsCountState, GetReservationsCountActionTypes, GET_RESERVATIONS_COUNT_DATA_REQUEST, GET_RESERVATIONS_COUNT_DATA_SUCCESS, GET_RESERVATIONS_COUNT_DATA_FAILURE } from "store/reducers/room/get-count/types";

const defaultState: GetReservationsCountState = {
  isLoading: false,
  errorMessage: ""
};

export default function getReservationsCount(state = defaultState, action: GetReservationsCountActionTypes): GetReservationsCountState {
  switch (action.type) {
    case GET_RESERVATIONS_COUNT_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_RESERVATIONS_COUNT_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case GET_RESERVATIONS_COUNT_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};